<template>
  <div class="withdrawal-page">
    <h2 class="font-500 auth-page-title">{{ $t('account.debit') }}</h2>
    <div class="auth-page-section">
      <loader :loading="loading" />
      <ic-tab
        class="mb-ten"
        v-model="reqType"
        :items="[
          { key: 'nominal', text: $t('cashout.type.type1') },
          { key: 'mse', text: $t('cashout.type.type2') },
        ]"
      />
      <div class="d-flex justify-content-end">
        <ic-button size="tn"
                   @click="toggleCreate"
                   type="button"
                   color="secondary"
                   data-toggle="modal"
                   data-target="#requestModal">
          <i class="far fa-file mr-2" />
          {{ $t('cashout.make-request') }}
        </ic-button>
      </div>




      <ic-dialog :show="isCreate">
        <div class="dialog-box">
          <div class="row align-items-center mb-ten">
            <div class="col">
              <h3 class="mb-0">{{ $t('cashout.make-request') }}</h3>
            </div>
            <a
              @click.stop="closeAndClearData"
              class="icon-btn close-btn mr-row"
            >
              <i class="sr sr-close"></i>
            </a>
          </div>


          <b-form @submit.prevent="sendRequest" class="py-3">
            <b-form-group style="color: var(--text-primary-color)" :label="$t('cashout.account-type')">
              <b-form-select
                  class="default"
                  v-model="reqType"
                  :options="reqTypes"
              ></b-form-select>
              <p v-if="reqType === 'nominal' && !!localBalance" class="body-2 font-500 text-right text-red" style="font-size: 11px !important;">
                {{ $t('account.available-balance')}}: {{ localBalance.availableBalance | currency('', '₮') }}
              </p>
            </b-form-group>
            <b-form-group
                style="color: var(--text-primary-color)"
                v-if="reqType === 'mse'"
                :label="$t('cashout.share-code')"
            >
              <b-form-select
                  class="default"
                  v-model="requestModel.share_code"
                  :options="mseShareCodes"
              ></b-form-select>
              <div class="error-message text-left" v-show="v$.requestModel.share_code.$errors.length">
                <div>{{$t('cashout.share-code')}} хэсгийг сонгоно уу</div>
              </div>
              <p class="body-2 font-500 text-right text-red" style="font-size: 11px !important;">
                {{ $t('account.available-balance')}}: {{mseCodeBalance | currency('', '₮')}}
              </p>
            </b-form-group>
            <b-form-group style="color: var(--text-primary-color)" :label="$t('cashout.amount')">
              <ic-input size="sm" currency v-model="requestModel.amount" />
              <div class="error-message text-left" v-show="v$.requestModel.amount.$errors.length">
                <div>{{$t('cashout.amount')}} талбарыг бөглөнө үү</div>
              </div>
              <div style="max-width: 400px">
                <p v-if="reqType === 'mse'" class="body-2 font-500 text-right text-red">{{ $t('account.mseFeeInfo') }}</p>
                <p v-if="reqType === 'nominal'" class="body-2 font-500 text-right text-red">{{ $t('account.nominalFeeInfo') }}</p>
              </div>
            </b-form-group>
            <b-form-group style="color: var(--text-primary-color)" :label="$t('cashout.bank-account')">
              <div style="display: flex !important;">
                <img class="mr-2" style="border-radius: 10px; max-width: 40px" v-if="bankLogo" :src="`/img/banks/${bankLogo}`">
                <ic-input class="w-100" size="sm" disabled :value="bankAccountInfo" />
              </div>
            </b-form-group>
            <b-form-group v-if="this.user"
              style="color: var(--text-primary-color)"
              :label="$t('cashout.info')">
              <ic-input size="sm" :placeholder="defaultDescription" v-model="requestModel.description" />
              <div class="error-message" v-show="v$.requestModel.description.$errors.length">
                <div>{{ $t('cashout.info') }} талбарыг бөглөнө үү</div>
              </div>
            </b-form-group>
            <div class="d-flex justify-content-end">
              <ic-button class="mr-ten" variant="outline-success">
                {{ $t('cashout.send') }}
              </ic-button>
              <ic-button color="danger" data-dismiss="modal" type="button" class="btn" @click="closeAndClearData()">
                {{ $t('cashout.refuse') }}
              </ic-button>
            </div>
          </b-form>
        </div>
      </ic-dialog>

      <div class="mt-2 px-1">
        <div
          v-if="!requests || !(requests && requests.length > 0)"
          class="item text-14 text-gray text-center"
        >
          <hr />
          <i class="far fa-file" />
          {{ $t('helper.empty') }}
        </div>
        <ul class="history-wrapper" ref="request-list" id="request-list">
          <cashout
            v-for="(item, i) in requests"
            :request="item"
            :key="i"
            :cancelRequest="cancelRequest"
          />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api/cashoutRequests'
import Cashout from '../../components/sidebar/Cashout/index.vue'
import { MseShareCodes, AccountType, BankIcons} from '../../constants'
import { unformat } from '../../plugins/currency-input/utils'
import { required, minValue, requiredIf } from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import CopyButton from '../../components/global/CopyButton/index.vue'
import {mapGetters, mapState} from "vuex";

const StateOption = {
  approved: { variant: 'success', text: 'Биелсэн' },
  cancelled: { variant: 'danger', text: 'Цуцалсан' },
  new: { variant: 'info', text: 'Шинэ' },
  done: { variant: 'success', text: 'Биелсэн' },
  null: { variant: 'dark', text: 'NA' },
  undefined: { variant: 'dark', text: 'NA' },
}

export default {
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    CopyButton,
    Cashout,
  },
  data() {
    return {
      StateOption,
      isLoading: false,
      isCreate: true,
      reqType: 'nominal',
      requestModel: {
        amount: 0,
        share_code: '',
        description: '',
        state: 'new',
      },
      requests: [],
      page: 1,
      HistoryLastPage: 1,
      mseShareCodes: MseShareCodes,
      reqTypes: AccountType,
      bankLogos: BankIcons,
      loading: false,
      mseCodeBalance: null,
    }
  },
  validations() {
    return {
      requestModel: {
        amount: {
          valid() {
            return (
              unformat(this.requestModel.amount, 2) > 0
            )
          },
        },
        share_code: {
          required: requiredIf(function() {
            return this.reqType === 'mse';
          }),
        },
        description: { required },
      }
    }
  },
  mounted() {
    this.page = 0
    if (this.user) {
    this.requestModel.description = `${this.user.register_number}, ${this.user.mobilenumber}`
    }
    // const listElm = document.querySelector('#request-list');
    const listElm = this.$refs['request-list']
    if (listElm) {
      listElm.addEventListener('scroll', () => {
        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          setTimeout(() => {
            this.page += 1
            if (this.page <= this.HistoryLastPage) this.fetchData()
          }, 400)
        }
      })
    }
    this.fetchData()
  },
  computed: {
    defaultDescription() {
    return this.user ? `${this.user.register_number}, ${this.user.mobilenumber}` : ''
    },
    ...mapState('user', ['user']),
    localBalance() {
      return this.$store.getters.localBalance
    },
    bankAccountInfo() {
      return (this.user && this.user.account_number) ? this.user.account_number : ''
    },
    bankLogo() {
      if (!this.user) return null;
      return this.bankLogos.find(x => x.value === this.user.bank_name).logo
    },
  },
  beforeDestroy() {
    // const elm = document.querySelector('#request-list');
    this.$refs['request-list'].removeEventListener('scroll', () => {})
  },
  methods: {
    closeAndClearData() {
      this.isCreate = false;
      this.requestModel = {
        amount: 0,
        share_code: '',
        description: '',
        state: 'new',
      }
    },
    mseBalance() {
      this.mseCodeBalance = this.requestModel.share_code === 9999 ? this.$store.getters.mseBalance :
          this.requestModel.share_code === 9991 ? this.$store.getters.govBond :
              this.requestModel.share_code === 9992 ? this.$store.getters.dividends : 0
    },
    async fetchData(pageParam = null, typeChanged = false) {
      this.isLoading = true
      try {
        const {
          data: { data, ...page },
        } = await api.getCashOutRequests({
          reqType: this.reqType,
          page: pageParam || this.page,
        })
        this.HistoryLastPage = page && page.last_page
        if (typeChanged) this.requests = [...data]
        else this.requests.push(...data)
      } catch (e) {
        this.requests = []
      }
      this.isLoading = false
    },
    setReqType(type) {
      this.reqType = type
    },
    toggleCreate() {
      this.isCreate = !this.isCreate
    },
    async sendRequest() {
      this.isLoading = true

      await this.v$.$validate()
      if (this.v$.$error) {
        return
      }

      try {
        this.requestModel.amount = unformat(this.requestModel.amount, 2)

        const { data } = await api.createRequest({
          account_type: this.reqType,
          ...this.requestModel,
        })
        await this.fetchData({}, true)
        this.isCreate = false
        this.$bvToast.toast(data ?? this.$t('helper.request-success'), {
          title: this.$t('helper.success'),
          variant: 'info',
        })
      } catch (e) {
        // this.$bvToast.toast(this.$t('helper.system-error'), {
        //   title: this.$t('helper.error'),
        //   variant: 'error',
        // })
        console.error(e);
      }
      this.closeAndClearData();
      this.isLoading = false
      $(".modal-backdrop").remove();
    },
    cancelRequest(item) {
      this.$swal({
        icon: 'warning',
        title: `Та ${this.$options.filters.currency(
          item.amount,
          '',
          '₮'
        )} дүнтэй хүсэлтийг цуцлах уу?`,
        confirmButtonText: this.$t('helper.cancel'),
        confirmButtonColor: '#ff7674',
        cancelButtonColor: '#c3c3c3',
        cancelButtonText: this.$t('helper.refuse'),
        showCancelButton: true,
        showConfirmButton: true,
        reverseButtons: false,
      })
        .then(async ({ dismiss, value }) => {
          if (!dismiss && !!value) {
            this.isLoading = true
            try {
              await api.cancelRequest(item)
              await this.fetchData({}, true)
              this.$bvToast.toast(this.$t('helper.cancel-success'), {
                title: this.$t('helper.success'),
                variant: 'info',
              })
            } catch (e) {
              this.$bvToast.toast(this.$t('helper.system-error'), {
                title: this.$t('helper.error'),
                variant: 'error',
              })
            }
            this.isLoading = false
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
  watch: {
    reqType(val) {
      this.fetchData('0', true)

      // Хэрэв ҮЦТХТ данс сонголтыг сонгосон тохиолдолд бэлэн мөнгийг default болгох
      if (val === 'mse') {
        this.requestModel.share_code = 9999;
      }
    },
    'requestModel.share_code' : {
      handler() {
        this.mseBalance()
      }
    }

  },
}
</script>

<style lang="scss" src="./Withdrawal.scss" />
